import { AppSettings } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_REQUEST_APP_SETTINGS = '_APP_SETTINGS/REQUEST';
const ACTION_LOADED_APP_SETTINGS = '_APP_SETTINGS/LOADED';
const ACTION_ERROR_APP_SETTINGS = '_APP_SETTINGS/ERROR';

export interface AppSettingsState {
  data?: AppSettings;
  loaded?: boolean;
  loading?: boolean;
  error?: any;
}

const initialState: AppSettingsState = {
  loaded: false,
  loading: false,
};

type RequestAppSettingsActionType = IAction<typeof ACTION_REQUEST_APP_SETTINGS>;
type AppSettingsLoadedActionType = IActionWithPayload<
  typeof ACTION_LOADED_APP_SETTINGS,
  AppSettings
>;
type AppSettingsErrorActionType = IActionWithPayload<
  typeof ACTION_ERROR_APP_SETTINGS,
  any
>;

type Actions =
  | RequestAppSettingsActionType
  | AppSettingsLoadedActionType
  | AppSettingsErrorActionType;

export const requestAppSettingsAction = (): RequestAppSettingsActionType => {
  return createAction(ACTION_REQUEST_APP_SETTINGS);
};

export const appSettingsLoadedAction = (
  data: AppSettings
): AppSettingsLoadedActionType => {
  return createActionWithPayload(ACTION_LOADED_APP_SETTINGS, data);
};

export const appSettingsErrorAction = (
  error: any
): AppSettingsErrorActionType => {
  return createActionWithPayload(ACTION_ERROR_APP_SETTINGS, error);
};

// reducer
export const appSettingsReducer = (
  state: AppSettingsState = initialState,
  action: Actions
): AppSettingsState => {
  switch (action.type) {
    case ACTION_REQUEST_APP_SETTINGS:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case ACTION_LOADED_APP_SETTINGS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        data: action.payload,
      };
    }
    case ACTION_ERROR_APP_SETTINGS:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
